module.exports = __webpack_public_path__ + "static/media/alum_goriz.7686b8db.png";